import type { OrcamentoResponse, StatusVersaoDto, VersaoResumoResponse } from '@triade/contracts';

/**
 * Rotulos e regras de EXIBICAO das versoes. Nada aqui calcula preco, lucro ou validade: o status, o `vencido`, a
 * validade e o sha256 vem da API. As regras abaixo so decidem qual botao aparece (a API continua validando tudo).
 */

export const ROTULO_VERSAO: Record<StatusVersaoDto, string> = {
  RASCUNHO: 'Rascunho editável',
  ENVIADA: 'Enviada · congelada',
  APROVADA: 'Aprovada',
  DESCARTADA: 'Descartada',
  IMPORTADA: 'Importada do XARP · somente leitura',
};

/** Numero exibido (`33392-v2`) vem da API; so monta o texto de um item do seletor. */
export function rotuloSeletorVersao(v: Pick<VersaoResumoResponse, 'numeroExibido' | 'status' | 'vencido'>): string {
  return `${v.numeroExibido} · ${ROTULO_VERSAO[v.status]}${v.vencido ? ' · Vencido' : ''}`;
}

export interface EntradaAcoes {
  /** Status da versao exibida. */
  versaoStatus: StatusVersaoDto;
  /** Numero da versao exibida (N >= 2 pode ser descartada). */
  versaoNumero: number;
  /** Situacao do cabecalho (ENVIADO, EM_NEGOCIACAO, APROVADO, PERDIDO, RASCUNHO). */
  situacao: OrcamentoResponse['status'];
  /** Ha um rascunho aberto em alguma versao do orcamento (so um por vez). */
  temRascunhoAberto: boolean;
  /** Permissao orcamento.editar (VENDEDOR so nos proprios; a API filtra). */
  podeEditar: boolean;
  /** Origem APP (importados nao geram versoes). */
  origemApp: boolean;
}

export interface AcoesVersao {
  editar: boolean;
  enviar: boolean;
  criarProxima: boolean;
  aprovar: boolean;
  descartar: boolean;
}

/** Quais acoes de versao aparecem. Permissao ausente = acao oculta; estado invalido = acao oculta (a API recusaria). */
export function acoesDaVersao(e: EntradaAcoes): AcoesVersao {
  const rascunho = e.versaoStatus === 'RASCUNHO';
  const enviadaEmAberto = e.versaoStatus === 'ENVIADA' && (e.situacao === 'ENVIADO' || e.situacao === 'EM_NEGOCIACAO');
  return {
    editar: e.podeEditar && rascunho,
    enviar: e.podeEditar && rascunho && e.origemApp && (e.situacao === 'RASCUNHO' || e.situacao === 'ENVIADO' || e.situacao === 'EM_NEGOCIACAO'),
    criarProxima: e.podeEditar && enviadaEmAberto && !e.temRascunhoAberto && e.origemApp,
    aprovar: e.podeEditar && enviadaEmAberto && e.origemApp,
    descartar: e.podeEditar && rascunho && e.versaoNumero >= 2,
  };
}
